export const EARLY_REPAYMENT_ACTIONS = {
  NOTIFY: 'notify',
  AWAITING_PAY: 'awaiting_pay',
  PAY_EARLY: 'pay_early',
  REGULAR_PAY: 'regular_pay',
  UNAVAILABLE: 'unavailable',
  NONE: 'none',
};

export function getEarlyRepaymentAction(item) {
  return item?.earlyRepayment?.action || null;
}

export function isShowRegularPayBtn(item) {
  return item?.status === 'current_debt' || item?.status === 'overdue';
}

export function isShowEarlyPayBtn(item) {
  return getEarlyRepaymentAction(item) === EARLY_REPAYMENT_ACTIONS.PAY_EARLY;
}

export function isShowNotifyMenu(item) {
  return getEarlyRepaymentAction(item) === EARLY_REPAYMENT_ACTIONS.NOTIFY;
}

export function isShowAwaitingIcon(item) {
  return getEarlyRepaymentAction(item) === EARLY_REPAYMENT_ACTIONS.AWAITING_PAY
    && item?.earlyRepayment?.notification?.expired === false;
}

export function formatEarlyRepaymentDate(dateStr) {
  if (!dateStr) {
    return '';
  }

  return new Date(dateStr).toLocaleDateString('ru-RU');
}

export function getAwaitingTooltip(item, t) {
  const er = item?.earlyRepayment;
  const sentAt = er?.notification?.sentAt || er?.notification?.sent_at;
  const payFrom = er?.payAvailableFrom || er?.pay_available_from;

  return t('message.profile.borrower.earlyRepayment.awaitingTooltip', {
    sentAt: formatEarlyRepaymentDate(sentAt),
    payFrom: formatEarlyRepaymentDate(payFrom),
  });
}

export function resolveEarlyRepaymentErrorMessage(error, t) {
  const data = error?.response?.data || {};
  const code = data.message || data.code || '';
  const reason = data.reason || '';

  const messages = {
    'loan.early-repayment.already-notified': t('message.profile.borrower.earlyRepayment.errors.alreadyNotified'),
    'loan.early-repayment.notify-unavailable': t(`message.profile.borrower.earlyRepayment.errors.notifyReason.${reason}`) || t('message.profile.borrower.earlyRepayment.errors.notifyUnavailable'),
    'loan.early-repayment.notification-required': t('message.profile.borrower.earlyRepayment.errors.notificationRequired'),
    'loan.early-repayment.pay-unavailable': t(`message.profile.borrower.earlyRepayment.errors.payReason.${reason}`) || t('message.profile.borrower.earlyRepayment.errors.payUnavailable'),
    'loan.early-repayment.amount-mismatch': t('message.profile.borrower.earlyRepayment.errors.amountMismatch'),
    'payment.status.waiting': t('message.profile.borrower.earlyRepayment.errors.paymentWaiting'),
    'card.src.not-found': t('message.profile.borrower.earlyRepayment.errors.cardSrcNotFound'),
    'card.dst.not-found': t('message.profile.borrower.earlyRepayment.errors.cardDstNotFound'),
    'user.add-card': t('message.profile.borrower.earlyRepayment.errors.addCard'),
    'payment.status.failed.common': t('message.profile.borrower.earlyRepayment.errors.paymentFailed'),
  };

  return messages[code] || code || t('message.profile.borrower.earlyRepayment.errors.default');
}
